<template>
<div class="col backgroundForm">
    <div class="col-md-6 offset-md-3">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Cambio de Comandante de Unidad de Superficie </h4>
            <p>Realiza la transferencia de la embarcacion a un nuevo propietario </p>       
        </div>
    </div>
    
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-capitan-list" data-toggle="tab" href="#search-owner" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="plus" /> Busqueda Personal</a>
            <a class="nav-item nav-link" id="nav-capitan-list" data-toggle="tab" href="#search-ship" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="plus" /> Busqueda Embarcación</a>
            <a class="nav-item nav-link" id="nav-capitan-list" data-toggle="tab" href="#transfer-ship" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="plus" /> Datos Finales</a>
        </div>
    </nav>
            
    <div class="tab-content" id="nav-tabContent">                
        <div class="tab-pane fade show active" id="search-owner" role="tabpanel" aria-labelledby="nav-new-tab" >
            <br>
                    
                    <h6 align="center">Busqueda y Seleccion de Personal</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <div v-if="person_select.id > 0" class="panel panel-default">

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="type_identification" class="badge badge-primary">Nombre Completo</label>
                                <input type="text" name="name_owner" id="name_owner" readonly class="form-control-plaintext" :value="person_select.name">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="number_identification" class="badge badge-primary">Numero Identificacion </label>
                                <input type="text" class="form-control-plaintext" :value="person_select.number_identification" name="number_identification" readonly>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="site_expedition" class="badge badge-primary">Telefono </label>
                                <input type="text" class="form-control-plaintext" :value="person_select.phone" name="number_identification" readonly>
                            </div>
                        </div>
                        <button class="btn btn-danger col-12 col-md-2 offset-md-5" @click="mCloseSelectPerson"><font-awesome-icon icon="times-circle" size="2x" /></button>
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-success active" @click="mViewSearchPerson">
                                <input class="form-check-input" type="radio" name="personSearch" id="personSearch1" v-model="optionSearchPerson" value="document" checked> Nombre 
                            </label>
                            <label class="btn btn-success" @click="mViewSearchPerson">
                                <input class="form-check-input" type="radio" name="personSearch" id="personSearch2" v-model="optionSearchPerson" value="name">No. Documento
                            </label>
                        </div>

                        <div class="form-group"> 
                            <label for="nombrePersona">{{ searchTypePerson }}</label>
                            <input type="text" class="form-control" id="data_person" v-model="data_person" :placeholder="searchTypePerson" autocomplete="off">
                            <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchTypePerson }} </small>
                        </div>
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="buscaDataPerson">Buscar</button>

                        <div class="table-responsive" v-if="list_person_select.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre Completo</th>
                                        <th>CI</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(persSelc, index) in list_person_select" :key="persSelc.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ persSelc.grado }} {{ persSelc.especialidad }} {{ persSelc.nombre_propietario }}</span>
                                        </td>
                                        <td>{{ persSelc.dato_identificacion }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectPersonOwner(persSelc)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>
        </div>
        <!-- end first tab -->

        <div class="tab-pane fade" id="search-ship" role="tabpanel" aria-labelledby="nav-new-tab" >
            <br>
                    
                    <h6 align="center">Busqueda y Seleccion de Embarcacion/Nave/Artefacto Naval</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <div v-if="ship_select.id > 0" class="panel panel-default">

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="type_identification" class="badge badge-primary">Nombre Embarcación</label>
                                <input type="text" name="name_owner" id="name_owner" readonly class="form-control-plaintext" :value="ship_select.name_boat">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="number_identification" class="badge badge-primary">Numero Identificacion </label>
                                <input type="text" class="form-control-plaintext" :value="ship_select.enrollment_old" name="number_identification" readonly>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="site_expedition" class="badge badge-primary">TRB </label>
                                <input type="text" class="form-control-plaintext" :value="ship_select.trb" name="number_identification" readonly>
                            </div>
                        </div>
                        <button class="btn btn-danger col-12 col-md-2 offset-md-5" @click="mCloseSelectShip"><font-awesome-icon icon="times-circle" size="2x" /></button>
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-success active" @click="mViewSearchShip">
                                <input class="form-check-input" type="radio" name="radiosShip" id="radiosShip1" v-model="optionSearchShip"  value="enrollment" checked> Nombre 
                            </label>
                            <label class="btn btn-success" @click="mViewSearchShip">
                                <input class="form-check-input" type="radio" name="radiosShip" id="radiosShip2" v-model="optionSearchShip" value="name">Matricula
                            </label>
                        </div>

                        <div class="form-group"> 
                            <label for="nombrePersona">{{ searchTypeShip }}</label>
                            <input type="text" class="form-control" id="data_person" v-model="data_ship" :placeholder="searchTypeShip" autocomplete="off">
                            <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchTypeShip }} </small>
                        </div>
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="buscaDataShip">Buscar</button>

                        <div class="table-responsive" v-if="list_ship_select.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre</th>
                                        <th>MATRICULA</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(shipSelc, index) in list_ship_select" :key="shipSelc.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ shipSelc.name_boat }}</span>
                                        </td>
                                        <td>{{ shipSelc.enrollment_old }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectShipOwner(shipSelc)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>
        </div>

        <!-- end second tab -->
        <div class="tab-pane fade" id="transfer-ship" role="tabpanel" aria-labelledby="nav-new-tab" >
            <br>
                    
                    <h6 align="center">Datos de la Transferencia/Relevo</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <div v-if="ship_select.id > 0 && person_select.id > 0" class="panel panel-default">
                        <div class="input-group col-12 col-md-10">
                            <h5 class="form-control-plaintext "> Embarcación/Nave/Artefacto Naval a Transferir</h5>
                        </div>
                        
                        <hr>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="type_identification" class="badge badge-primary">Nombre Embarcación</label>
                                <input type="text" name="name_owner" id="name_owner" readonly class="form-control-plaintext" :value="ship_select.name_boat">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="number_identification" class="badge badge-primary">Numero Identificacion </label>
                                <input type="text" class="form-control-plaintext" :value="ship_select.enrollment_old" name="number_identification" readonly>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="site_expedition" class="badge badge-primary">TRB </label>
                                <input type="text" class="form-control-plaintext" :value="ship_select.trb" name="number_identification" readonly>
                            </div>
                        </div>

                        <div class="input-group col-12 col-md-10">
                            <h5 class="form-control-plaintext "> Datos Anterior Comandante UU.SS.</h5>
                        </div>
                        
                        <hr>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="type_identification" class="badge badge-primary">Anterior Propietario</label>
                                <input type="text" name="name_owner" id="name_owner" readonly class="form-control-plaintext" :value="old_owner.name">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="number_identification" class="badge badge-primary">Numero Identificacion </label>
                                <input type="text" class="form-control-plaintext" :value="old_owner.documento" name="number_identification" readonly>
                            </div>
                        </div>
                        <div class="input-group col-12 col-md-10">
                            <h5 class="form-control-plaintext ">Datos Nuevo Comadante UU.SS.</h5>
                        </div>
                        
                        <hr>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="type_identification" class="badge badge-primary">Nombre Completo</label>
                                <input type="text" name="name_owner" id="name_owner" readonly class="form-control-plaintext" :value="person_select.name">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="number_identification" class="badge badge-primary">Numero Identificacion </label>
                                <input type="text" class="form-control-plaintext" :value="person_select.number_identification" name="number_identification" readonly>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="site_expedition" class="badge badge-primary">Telefono </label>
                                <input type="text" class="form-control-plaintext" :value="person_select.phone" name="number_identification" readonly>
                            </div>
                        </div>

                        <div class="form-group"> 
                            <label for="nombrePersona">Documentos que respaldan la Transferencia u Relevo(Sirvase aclarar los documentos )</label>
                            <textarea name="documents_transfer" id="documents_transfer" cols="30" rows="3" class="form-control" placeholder="OGD Memorandum XYZ" v-model="description_transfer"></textarea>
                        </div>
                        
                        <button class="btn btn-danger col-12 col-md-2 offset-md-5" @click="mUpdateOwner"><font-awesome-icon icon="exchange-alt" size="2x" /></button>
                        
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>

                        <div class="form-group"> 
                            <div class="alert alert-info">Seleccione una Nave y una Persona</div>
                        </div>
                     </div>
                    </transition>
        </div>

    </div>
    <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
const qs = require('qs');

import modalLoading from '../modal/modalLoading';


export default {
    name:'admin-user',
    data(){
        return{
            description_transfer:null,
            owner:{},
            person_select:{id:0},
            list_person_select:[],
            ship_select:{id:0},
            list_ship_select:[],
            types_identification:[],
            citys:[],
            countrys:[],
            status_send:true,
            modal_load_id:'id_owner_new',
            modal_load_title:'Registrando', 
            optionSearchShip:'name',
            optionSearchPerson:'name',
            data_person:null,
            data_ship:null,
            optionSearch:'name',
            old_owner:{id:0},
            dts_transfer:null,
            
        }
    },
    mounted(){
        // if(Vue.auth.getToken()){
        //     axios.defaults.headers.common['Authorization']=`Bearer ${Vue.auth.getToken()}`;
        // }
        // console.log(axios.defaults.headers)
    },
    methods:{
        mShowModalUP(idM){
            $('#'+idM).modal('show');
        },
        mCloseModalUP(idM){
            $('#'+idM).modal('hide');
        },
        mValidateDescriptionChange(){
            try {
                let auxDescription=this.description_transfer.trim();
                if(this.description_transfer===null || auxDescription.length===0){
                    toastr.error('Indique los documentos que sustentan la transferencia', 'Error P-01');
                    return false;
                }
                return true;    
            } catch (error) {
                console.log('error ')
            }
            
        },
        mUpdateOwner(){
            if(this.mValidateDescriptionChange()){
                let message = {
                    title: 'Cambio de Propietario',
                    body: `¿Desea Registrar el cambio de Propietario de la Embarcacion con Matricula <b>${this.ship_select.enrollment_old}</b>?`
                    }
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // subimos la fotografia
                            this.mShowModalUP(this.modal_load_id);
                            try {                                
                                let nprop={
                                    id_person:this.person_select.id,
                                    ship:this.ship_select.id,
                                    detail_transfer:this.description_transfer
                                }

                                // setTimeout(()=>{
                                //     console.log('termino de registrar')
                                //     this.mCloseModalUP(this.modal_load_id);
                                // }, 3000)
                                // let fu= await axios.post(`upPhotoShip`, qs.stringify(sa));
                                let regOwner= await axios.post(`transferOwner?api_token=${Vue.auth.getToken()}`, qs.stringify(nprop));
                                    
                                if(regOwner.data[0].status){
                                    toastr.success(regOwner.data[0].respuesta, 'Exito');
                                    this.mCloseSelectPerson();
                                    this.mCloseSelectShip();
                                    setTimeout(()=>{
                                        this.mCloseModalUP(this.modal_load_id);
                                        this.list_ship_select=[];
                                        this.data_ship=null;
                                    }, 3000) 
                                    
                                }else{
                                    toastr.error(fd.data[0].respuesta, 'Error');
                                }                                                           

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso', 'Error P-01')
                                    this.mCloseModalUP(this.modal_load_id);                                
                                }, 3000)
                            }

                            setTimeout(()=>{                
                                        this.mCloseModalUP(this.idModalL);
                            }, 1000)
                        }else{
                            console.log('No se guardo la ordop')
                            // console.log(this.s_pro_ordop);
                        }
                    })
            }else{
                toastr.error('Indique los documentos que sustentan la transferencia', 'Error P-01')
            }
            console.log('enviando al servidor')
        },
        mViewSearchShip(event){
            // console.log(event);
            let radios=$("input[type=radio]").parent('label');
            console.log(radios);
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            // console.log(radioV);
            this.optionSearchShip=radioV;
        },
        mViewSearchPerson(event){
            console.log(event);
            let radios=$("input[type=radio]").parents('label');
            console.log(radios);
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            console.log(radioV);
            this.optionSearchPerson=radioV;
        },
        mCloseSelectPerson(){
            this.person_select.id=0;
            this.person_select.type_identification=0;
            this.person_select.number_identification=0;
            this.person_select.site_expedition=0;
            this.person_select.name=null;
            this.person_select.mobile=null;          
        },
        mSelectPersonOwner(sp){
            this.person_select.id=sp.id;
            this.person_select.type_identification=sp.tipo_identificacion;
            this.person_select.number_identification=sp.dato_identificacion;
            this.person_select.site_expedition=sp.id_expedido;
            this.person_select.name=sp.nombre_propietario;
            this.person_select.mobile=sp.celular;
            // this.mChangeOwnerIdentificationEdit();
        },
        buscaDataPerson(){
            // console.log(`${this.optionSearch} tipo`);
            // console.log(`${this.data_person}`);
            if(this.data_person !== null || this.data_person.trim().length > 0 ){
                console.log('enviando al servidor');
                axios.get(`searchOwnerType/${this.data_person}/${this.optionSearchPerson}?api_token=${Vue.auth.getToken()}`)
                    .then((res) => {                    
                        this.list_person_select = res.data
                        // this.users = res.data.items
                    }).catch(error => {
                        console.log(error);
                    })
            }else{
                toastr.warning('Indique un valor de busqueda', 'Dato Busqueda');
            }
        },
        buscaDataShip(){
            this.list_ship_select=[];
            // console.log(`${this.optionSearch} tipo`);
            // console.log(`${this.data_person}`);
            if(this.data_ship !== null || this.data_ship.trim().length > 0 ){
                // console.log('enviando al servidor');
                axios.get(`searchNameBoat/${this.optionSearchShip}/${this.data_ship}?api_token=${Vue.auth.getToken()}`)                
                .then((res) => {                    
                        this.list_ship_select = res.data
                        // this.users = res.data.items
                    }).catch(error => {
                        console.log(error);
                    })
            }else{
                toastr.warning('Indique un valor de busqueda', 'Dato Busqueda');
            }
        },
        mCloseSelectShip(){
            this.ship_select.id=0;
            this.ship_select.name_boat=null;
            this.ship_select.enrollment=null;
            this.ship_select.enrollment_old=null;
            this.ship_select.trb=null;
            this.ship_select.trn=null;
            this.old_owner.id=0;
            this.old_owner.name=null;
            this.old_owner.documento=null;
        },
        mSelectShipOwner(sbp){
            this.ship_select.id=sbp.id_boat;
            this.ship_select.name_boat=sbp.name_boat;
            this.ship_select.enrollment=sbp.enrollment;
            this.ship_select.enrollment_old=sbp.enrollment_old;
            this.ship_select.trb=sbp.trb;
            this.ship_select.trn=sbp.trn;
            this.old_owner.id=sbp.id_propietario;
            this.old_owner.name=sbp.nombre_propietario;
            this.old_owner.documento=sbp.dato_identificacion;
            // this.mChangeOwnerIdentificationEdit();
        }
    },
    components:{
        'modal-loading':modalLoading
    },
    computed:{
        searchTypeShip(){
            switch(this.optionSearchShip){
                case 'name':
                    return 'Nombre de la Nave';
                break;

                case 'enrollment':
                    return 'Matricula de la Nave';
                break;
            }
        },
        searchTypePerson(){
            switch(this.optionSearchPerson){
                case 'name':
                    return 'Nombre de la Persona';
                break;

                case 'document':
                    return 'Cedula de la Persona';
                break;
            }
        }
    },
    filters:{
        upperCase(value){
            return value.toUpperCase();
        }
    }
}
</script>

<style>
    .required-text{
        color:red; 
        font-weight:bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/matriculacion/ChangeOwnerShip.vue